import { LEGEND_ENTRIES } from "../utils/taskCalendar";

export default function CalendarLegend({ exclude = [], counts, selected, onToggle }) {
  const entries = LEGEND_ENTRIES.filter((l) => !exclude.includes(l.state));
  const interactive = typeof onToggle === "function";

  return (
    <div className="cal-legend">
      {entries.map((l) => {
        const swatch = <span className={`cal-legend-swatch cal-task ${l.state}`} />;
        const count = counts && <span className="cal-legend-count">{counts[l.state] ?? 0}</span>;

        if (!interactive) {
          return (
            <span key={l.state} className="cal-legend-item">
              {swatch}
              {l.label}
              {count}
            </span>
          );
        }

        return (
          <label
            key={l.state}
            className="cal-legend-item"
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            <input
              type="checkbox"
              checked={selected ? selected.has(l.state) : true}
              onChange={() => onToggle(l.state)}
              style={{ accentColor: "var(--primary-600)", cursor: "pointer", margin: 0 }}
            />
            {swatch}
            {l.label}
            {count}
          </label>
        );
      })}
    </div>
  );
}
